import React, { useContext } from "react";

const OrientationMarkers = ({markers}) => {

  return (
    <>
      <div className="viewport-overlay-value viewport-overlay-orientation-top">{markers?.top}</div>
      <div className="viewport-overlay-value viewport-overlay-orientation-left">{markers?.left}</div>
    </>
  );
};

export default OrientationMarkers;
